/* dataMapping.component.js */

import dataMappingController from "./dataMapping.controller";

/**
 * @desc component for editing Data Mappings when creating or editing a custom product
 * @example <data-mapping></data-mapping>
 */

const upiDataMapping = {
    bindings: {
        product: '<',
        saveStep: '<',
        isCreate: '<'
    },
    controller: dataMappingController,
    controllerAs: 'dmvm',
    templateUrl: '/App/Components/Connections/CustomProductConnection/DataMapping/dataMapping.tmpl.html'
};

export default upiDataMapping;